import { useState } from 'react';
import PolicyPageShell from './PolicyPageShell';
import PolicyDocumentContent from './PolicyDocumentContent';
import { PolicyDocument, PolicyDocumentType } from '../services/policyDocuments';

interface PolicyDocumentPageProps {
  type: PolicyDocumentType;
  title: string;
}

/**
 * Public policy page (`/terms`, `/privacy`, task 441).
 *
 * Wraps the shared `PolicyDocumentContent` body in the standalone public-page
 * shell. The shell renders the page title and — once the content component
 * reports the loaded document via `onLoaded` — its version / effective date.
 * A fetch failure surfaces inside `PolicyDocumentContent` as a retry state and
 * never blocks the page: these pages gate nothing.
 */
export default function PolicyDocumentPage({ type, title }: PolicyDocumentPageProps) {
  const [meta, setMeta] = useState<{ version: string; effectiveAt: string } | null>(null);

  return (
    <PolicyPageShell title={title} meta={meta}>
      <PolicyDocumentContent
        type={type}
        onLoaded={(document: PolicyDocument) =>
          setMeta({ version: document.version, effectiveAt: document.effectiveAt })
        }
      />
    </PolicyPageShell>
  );
}
